/**
 * ReaderFontControls Component - MA-ARCH-162
 * 
 * Extracted from ScriptPlay.jsx - Font size adjustment controls with back navigation.
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { Separator as UiSeparator } from '@/components/ui/separator';
import { ArrowLeft, Plus, Minus } from 'lucide-react';

/**
 * @param {Object} props
 * @param {boolean} props.showBackButton - Whether to show the back navigation button
 * @param {Function} props.onBack - Callback when back button is clicked
 * @param {Function} props.onIncrease - Callback to increase font size
 * @param {Function} props.onDecrease - Callback to decrease font size
 */
export function ReaderFontControls({
  showBackButton,
  onBack,
  onIncrease,
  onDecrease,
}) {
  return (
    <div className="flex items-center justify-end gap-1" data-testid="runner-font-controls">
      {showBackButton && (
        <>
          <Button
            variant="secondary"
            size="icon"
            className="h-8 w-8 rounded-full bg-white/10 text-slate-100 ring-1 ring-white/10 hover:bg-white/15"
            onClick={onBack}
            data-testid="runner-back-button"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>

          <UiSeparator
            orientation="vertical"
            className="mx-1 h-6 bg-white/10"
          />
        </>
      )}

      <Button
        variant="secondary"
        size="icon"
        className="h-8 w-8 rounded-full bg-white/10 text-slate-100 ring-1 ring-white/10 hover:bg-white/15"
        onClick={onDecrease}
        data-testid="runner-font-decrease"
      >
        <Minus className="h-4 w-4" />
      </Button>

      <Button
        variant="secondary"
        size="icon"
        className="h-8 w-8 rounded-full bg-white/10 text-slate-100 ring-1 ring-white/10 hover:bg-white/15"
        onClick={onIncrease}
        data-testid="runner-font-increase"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}

export default ReaderFontControls;
